export default __webpack_public_path__ + "static/media/content-deco-1.671cd9cf.webp";